import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getRecords } from '../api';

// 日付を YYYY-MM-DD 形式の文字列に変換
const toDateString = (date) => date.toISOString().split('T')[0];
// 今日の日付を取得
const today = () => new Date();

// 月数減算
const subtractMonths = (date, months) => {
  const d = new Date(date);
  d.setMonth(d.getMonth() - months);
  return d;
};


const PRESETS = [
  { label: '1ヶ月', months: 1 },
  { label: '3ヶ月', months: 3 },
  { label: '6ヶ月', months: 6 },
  { label: '全期間', months: null },
];

const HistoryPage = () => {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState(toDateString(subtractMonths(today(), 6)));
  const [endDate, setEndDate] = useState(toDateString(today()));
  const navigate = useNavigate();

  const fetchRecords = (start, end) => {
    setLoading(true);
    const params = {};
    if (start) params.startDate = start;
    if (end) params.endDate = end;
    getRecords(params)
      .then((res) => setRecords(res.data))
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchRecords(startDate, endDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFilter = () => fetchRecords(startDate, endDate);

  // プリセット適用
  const applyPreset = (months) => {
    const todayStr = toDateString(today());
    if (months === null) {
      setStartDate('');
      setEndDate(todayStr);
      fetchRecords('', todayStr);
    } else {
      const start = toDateString(subtractMonths(today(), months));
      setStartDate(start);
      setEndDate(todayStr);
      fetchRecords(start, todayStr);
    }
  };

  // 日付 > 部位 > 種目 でグループ化
  const grouped = records.reduce((acc, record) => {
    const { date, bodyPart, exercise } = record;
    if (!acc[date]) acc[date] = {};
    if (!acc[date][bodyPart]) acc[date][bodyPart] = {};
    if (!acc[date][bodyPart][exercise]) acc[date][bodyPart][exercise] = [];
    acc[date][bodyPart][exercise].push(record);
    return acc;
  }, {});

  // 日付降順
  const sortedDates = Object.keys(grouped).sort((a, b) => b.localeCompare(a));

  return (
    <div className="page">
      <h1>トレーニング履歴</h1>

      <div className="history-filter">
        <div className="history-filter-presets">
          {PRESETS.map(({ label, months }) => (
            <button
              key={label}
              className="preset-btn"
              onClick={() => applyPreset(months)}
            >
              {label}
            </button>
          ))}
        </div>
        <div className="history-filter-dates">
          <input
            type="date"
            value={startDate}
            max={endDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <span>&nbsp;〜&nbsp;</span>
          <input
            type="date"
            value={endDate}
            min={startDate}
            max={toDateString(today())}
            onChange={(e) => setEndDate(e.target.value)}
          />
          {/* <button className="filter-btn" onClick={handleFilter}>
            絞り込み
          </button> */}
        </div>
        <div>
          <button className="filter-btn" onClick={handleFilter}>
            絞り込み
          </button>
        </div>
      </div>

      {loading ? (
        <div className="loading">読み込み中...</div>
      ) : sortedDates.length === 0 ? (
        <p>履歴がありません</p>
      ) : (
        sortedDates.map((date) => (
          <div key={date} className="history-group">
            <h2>{date}</h2>
            {Object.keys(grouped[date]).map((bodyPart) => (
              <div key={bodyPart} className="history-body-part">
                <h3>{bodyPart}</h3>
                {Object.keys(grouped[date][bodyPart]).map((exercise) => (
                  <div key={exercise} className="history-exercise">
                    <h4>{exercise}</h4>
                    <table>
                      <thead>
                        <tr>
                          <th>セット</th>
                          <th>重量 (kg)</th>
                          <th>レップ数</th>
                        </tr>
                      </thead>
                      <tbody>
                        {grouped[date][bodyPart][exercise]
                          .sort((a, b) => a.setNumber - b.setNumber)
                          .map((record) => (
                            <tr key={record.recordId}>
                              <td>{record.setNumber}</td>
                              <td>{record.weight}</td>
                              <td>{record.reps}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                ))}
              </div>
            ))}
          </div>
        ))
      )}
    </div>
  );
};

export default HistoryPage;
